import { CounterSignatureLocation, CounterSignatureRequestStatus } from "../common/enums";

type CounterSignatureRequest = {
    id: number;
    workPermitId: number;
    requestedUserId: string;
    requestedCompanyId: string;
    requestedCompanyDepartmentId: number | undefined;

    requestedUserEmailSnapshot: string;
    requestedCompanyNameSnapshot: string;
    requestedCompanyDepartmentNameSnapshot: string;

    status: CounterSignatureRequestStatus;
    counterSignatureLocation: CounterSignatureLocation;

    canManage: boolean;
};

export default CounterSignatureRequest;

export function CounterSignatureRequest_empty(location: CounterSignatureLocation): CounterSignatureRequest {
    return {
        id: 0,
        workPermitId: 0,
        requestedUserId: "",
        requestedCompanyId: "",
        requestedCompanyDepartmentId: undefined,
        requestedUserEmailSnapshot: "",
        requestedCompanyNameSnapshot: "",
        requestedCompanyDepartmentNameSnapshot: "",

        status: CounterSignatureRequestStatus.NotSigned,
        counterSignatureLocation: location,
        canManage: false
    };
}

export function CounterSignatureRequest_userIsRequested(counterSignatureRequest: CounterSignatureRequest): boolean {
    return !!counterSignatureRequest.requestedUserId;
}

export function CounterSignatureRequest_companyIsRequested(counterSignatureRequest: CounterSignatureRequest): boolean {
    return !!counterSignatureRequest.requestedCompanyId;
}

export function CounterSignatureRequest_departmentIsRequested(
    counterSignatureRequest: CounterSignatureRequest
): boolean {
    return !!counterSignatureRequest.requestedCompanyDepartmentId;
}

export function CounterSignatureRequest_isActive(counterSignatureRequest: CounterSignatureRequest): boolean {
    return (
        !!counterSignatureRequest &&
        counterSignatureRequest.id !== 0 &&
        counterSignatureRequest.status !== CounterSignatureRequestStatus.Cancelled
    );
}
